import {
  BookOpenIcon,
  ListChecksIcon,
  FileTextIcon,
  LightbulbIcon,
  ClipboardCheckIcon,
  SlidersHorizontalIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '10 tomes de musique',
    description: 'Du premier jeu d’écoute au projet autonome, avec des niveaux indicatifs.',
  },
  {
    icon: ListChecksIcon,
    title: 'Des séances structurées',
    description: 'Objectifs, consignes et étapes pour guider la pratique.',
  },
  {
    icon: FileTextIcon,
    title: 'Des supports élèves',
    description: 'Exercices, fiches et cartes visuelles pour faire travailler la classe.',
  },
  {
    icon: LightbulbIcon,
    title: 'Des créations et projets',
    description: 'Travaux pratiques et tâches pour expérimenter et présenter ses choix.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Des corrigés et critères',
    description: 'Réponses attendues pour les exercices fermés et repères pour les productions ouvertes.',
  },
  {
    icon: SlidersHorizontalIcon,
    title: 'Des pistes d’adaptation',
    description: 'Des options selon les acquis, l’organisation du groupe et les moyens disponibles.',
  },
]
